const PATHS: Record<string, React.ReactNode> = {
  recommended: <path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8-4.3-4.1 5.9-.9L12 3.5z" />,
  'microsoft-365-suites': (
    <>
      <rect x="4" y="4" width="7" height="7" rx="1" />
      <rect x="13" y="4" width="7" height="7" rx="1" />
      <rect x="4" y="13" width="7" height="7" rx="1" />
      <rect x="13" y="13" width="7" height="7" rx="1" />
    </>
  ),
  'office-365-suites': (
    <>
      <path d="M7 3h7l4 4v14H7V3z" />
      <path d="M14 3v4h4M10 12h5M10 16h5" />
    </>
  ),
  'security-identity': <path d="M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3z" />,
  'compliance-governance': (
    <>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4V3h6v1M9 13l2 2 4-4" />
    </>
  ),
  'dynamics-365': <path d="M5 20V10M12 20V4M19 20v-7M3 20h18" />,
  'power-platform': <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />,
  'communication-collaboration': <path d="M4 5h16v11H9l-5 4V5z" />,
  'infrastructure-management': (
    <>
      <rect x="4" y="4" width="16" height="7" rx="1.5" />
      <rect x="4" y="13" width="16" height="7" rx="1.5" />
      <path d="M8 7.5h.01M8 16.5h.01" />
    </>
  ),
  'project-visualization': (
    <>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 4v16M4 9h16" />
    </>
  ),
  'google-workspace': <path d="M20 12a8 8 0 1 1-2.34-5.66M20 12h-7" />,
}

export default function CatalogCategoryIcon({ slug, className }: { slug: string; className?: string }) {
  const path = PATHS[slug]
  if (!path) return null
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false">
      {path}
    </svg>
  )
}
